// CULTIVATION UNIT
export const GET_CULTIVATION_UNITS = '/cultivation_unit/query';
export const GET_CULTIVATION_UNIT = '/cultivation_unit/';
export const POST_CULTIVATION_UNIT = '/cultivation_unit/';
export const PUT_CULTIVATION_UNIT = '/cultivation_unit/';
export const DELETE_CULTIVATION_UNIT = '/cultivation_unit/';
export const CHECK_CULTIVATION_UNIT_EXISTS = '/cultivation_unit/query';
